import { useQuery } from '@tanstack/react-query';

import {
  partnersMembersApi,
  partnersMembersApiKeys,
} from '@/api/routes/partners/partners.members.api';

/** People with access to the account and the open invites (Conta, P15). */
export const usePartnersReadMembers = () => {
  return useQuery({
    queryKey: partnersMembersApiKeys.all,
    queryFn: () => partnersMembersApi.list().then((res) => res.data),
  });
};
